// Newsletter-Button wurde auf Wunsch entfernt.
export default function NewsletterButtonConditional() {
  return null;
}
